import React, { forwardRef } from "react";
import visibility from "../../assets/images/visibility.png";
import visibilityOff from "../../assets/images/visibilityOff.png";

export default forwardRef((props, ref) => (
  <span className="missionSpan">
    <img
      alt={`${props.value}`}
      src={props.value ? visibility : visibilityOff}
      className="missionIcon"
    />
  </span>
));
